export const communityPropertyStateNames = ['arizona','california','idaho','louisiana','nevada','new mexico','texas','washington','wisconsin']

export const communityPropertyStateCodes = ['az','ca','id','la','nv','nm','tx','wa','wi']